module.exports = __webpack_public_path__ + "img/cooperation_bg_o2o@.4b30d093.png";